<template>
  <MainLayout>
    <v-container>
      <main-menu />
      <div class="text-xs-right">
        <v-btn v-show="!isEdit" icon outline color="primary" @click="isEdit = !isEdit">
          <v-icon>edit</v-icon>
        </v-btn>
      </div>
      <template v-if="!isEdit">
        <v-layout class="my-3">
          <v-flex> Warroom Client ID </v-flex>
          <v-flex class="text-xs-right"> {{ input.warroom_clientid || '-' }} </v-flex>
        </v-layout>
        <v-layout class="my-3">
          <v-flex> Warroom Client Secret </v-flex>
          <v-flex class="text-xs-right"> {{ input.warroom_client_secret || '-' }} </v-flex>
        </v-layout>
        <v-layout class="my-3">
          <v-flex> Use warroom production endpoint </v-flex>
          <v-flex class="text-xs-right">
            <toggle-button
              :value="input.use_warroom_endpoint_production"
              :sync="true"
              :color="$vuetify.theme.success"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
              style="display: inline-block"
              @change="handleChangeUseWarroomEndpointProduction()"
            />
          </v-flex>
        </v-layout>
      </template>
      <template v-else>
        <WarroomConfigManage
          :value="input"
          @onChangeConfig="handleChangeWarroomSetting"
          @onCancel="isEdit = false"
        />
      </template>
    </v-container>
  </MainLayout>
</template>

<script>
import MainMenu from './MainMenu.vue'
import { ToggleButton } from 'vue-js-toggle-button'
import pageConfigApi from '@/api/page-config'
import { mapGetters } from 'vuex'
import { handleApiError } from '@/api/util'
import WarroomConfigManage from './WarroomConfigManage.vue'
export default {
  components: {
    MainMenu,
    ToggleButton,
    WarroomConfigManage
  },
  data() {
    return {
      isEdit: false,
      input: {
        warroom_clientid: '',
        warroom_client_secret: '',
        use_warroom_endpoint_production: false
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    const keys = Object.keys(this.input)
    keys.forEach((element) => {
      if (Object.hasOwnProperty.call(this.selectedBot, element)) {
        this.input[element] = this.selectedBot[element]
      }
    })
  },
  methods: {
    handleChangeUseWarroomEndpointProduction() {
      this.handleChangeWarroomSetting({
        ...this.input,
        use_warroom_endpoint_production: !this.input.use_warroom_endpoint_production
      })
    },
    async handleChangeWarroomSetting(data) {
      this.isEdit = false
      try {
        this.$store.dispatch('loading')
        const response = await pageConfigApi.postWarroomConfig({
          data: {
            ...data,
            page_id: this.selectedBot.pageid
          }
        })
        if (response.status == 200 || response.status == 204) {
          const currentBot = {
            ...this.selectedBot,
            ...data
          }

          const newbotlist = this.$store.state.botlist
          const botIndex = newbotlist.findIndex((oldbot) => {
            return this.selectedBot.pageid == oldbot.pageid
          })
          if (newbotlist) {
            newbotlist[botIndex] = currentBot
            this.$store.dispatch('updateBotlist', newbotlist)
          }

          this.$store.dispatch('selectBot', currentBot)
          this.$swal.fire({
            title: this.$t('Successfully'),
            type: 'success'
          })
        }
        this.$store.dispatch('clear_loading')
      } catch (error) {
        handleApiError(error)
        this.$store.dispatch('clear_loading')
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/AdvancedSetting/WarroomConfig.vue